/**
 * Created by dimah on 30/07/17.
 */

import { AbstractDTO } from "./abstract";

export class MobileLinksDTO extends AbstractDTO {
    static ATTR_ID = "id";
    static ATTR_LOCATION = "location";
    static ATTR_TITLE = "title";
    static ATTR_LINK = "link";
    static ATTR_ICON = "icon";
    static ATTR_TYPE = "type";
    static ATTR_ORDER = "order";
    static ATTR_IS_ACTIVE = "is_active";
    static ATTR_IS_LOGIN = "is_login";
    static ATTR_ACL_DEFINITION = "acl_definition";

    id: number;
    location: string;
    title: string;
    link: string;
    icon: string;
    type: string;
    order: number;
    is_active: number;
    is_login: number;
    acl_definition: number;
    class: string;
    query_params: object;
    base_link: string;
    fragment: string;
    tab: string;
    isExternalLink: boolean;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = Number(attributes['id']) || 0;
        this.location = attributes['location'] || "";
        this.title = attributes['title'] || "";
        this.link = attributes['link'] || "";
        this.icon = attributes['icon'] || "";
        this.type = attributes['type'] || "";
        this.order = Number(attributes['order']) || 0;
        this.is_active = Number(attributes['is_active']) || 0;
        this.is_login = Number(attributes['is_login']) || 0;
        this.class = attributes['class'] || "";
        this.setQueryParams(attributes['link'] || "");
        this.setBaseLink(attributes['link'] || "");
        this.setFragment(attributes['link'] || "")
        this.tab = attributes['tab'];
        this.acl_definition = attributes['acl_definition'];
        this.isExternalLink = this.getIsExternalLink(this.link);
    }

    setQueryParams(link) {
        const queryParamsString =  link.split('?')[1]? link.split('?')[1] : '';
        const queryParams = {};
        if(queryParamsString) {
            queryParamsString.split('&').forEach(x => {
                const params = x.split('=');
                queryParams[params[0]] = params[1];
            });
        }
        this.query_params = queryParams;
    }

    setBaseLink(link) {
        this.base_link = link? link.split('?')[0].split('#')[0] : '';
    }

    setFragment(link) {
        this.fragment = link? decodeURI(link).split('?')[0].split('#')[1] : '';
        this.fragment = this.fragment? this.fragment : null;
    }

    getIsExternalLink(link) {
        return /^https?:\/\//i.test(link);
    }
}
